import moment from "moment";

const Formatter = {
  toClockDisplay(seconds) {
    if (seconds <= 0) {
      return "0:00";
    }
    let minutes = parseInt(seconds / 60);
    return `${minutes}:${`0${seconds % 60}`.slice(-2)}`;
  },

  getFriendlyTimestamp(isoDate) {
    return moment(isoDate).format("dddd, MMMM D, YYYY h:mm A");
  },

  getISODateString(dateObject) {
    return moment(dateObject).format("YYYY-MM-DD");
  },

  isISODate(potentialIsoDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(potentialIsoDate);
  },

  getDateObjectFromISODate(isoDate) {
    return moment(isoDate).toDate();
  },
};

export default Formatter;



// WEBPACK FOOTER //
// ./src/formatter.js